'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var React = require('react');
var ProgressBar_web_styles = require('./ProgressBar.web.styles.cjs');

/**
 *
 * This component is used to display the progress of a task
 *
 * {@link https://aviary.fullscript.io/latest/components/progress-bar/web-XsA0eS42-XsA0eS42 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/ProgressBar/ProgressBar.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const ProgressBar = ({ progress, customCss, ...rest })=>{
    const theme = react.useTheme();
    const trueProgress = Math.min(100, Math.max(0, progress));
    const progressIndicatorStyles = React.useMemo(()=>[
            ProgressBar_web_styles.progressIndicator(theme, trueProgress)
        ], [
        theme,
        trueProgress
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: [
            ProgressBar_web_styles.container,
            customCss
        ],
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": trueProgress,
        "aria-valuetext": `${trueProgress}% complete`,
        "data-state": trueProgress === 100 ? "complete" : "incomplete",
        "data-value": trueProgress,
        "data-max": 100,
        "data-testid": "aviary-progress-bar",
        role: "progressbar",
        ...rest,
        children: /*#__PURE__*/ jsxRuntime.jsx("div", {
            "data-testid": "aviary-progress-bar-indicator",
            "data-value": trueProgress,
            "data-max": 100,
            "data-state": trueProgress === 100 ? "complete" : "incomplete",
            css: progressIndicatorStyles
        })
    });
};

exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.web.cjs.map
